<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="混剪标题">
                  <el-input style="width: 177px" v-model="queryForm.mexcutTitle"></el-input>
              </el-form-item>
              <el-form-item label="混剪状态">
<!--                  <el-input style="width: 177px" v-model="queryForm.mexcutStatus"></el-input>-->
                  <el-select v-model="queryForm.mexcutStatus" placeholder="请选择" clearable style="width: 177px">
                      <el-option
                          v-for="item in statusList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.value"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 177px" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                               :value="queryForm.userId" :limit='1'
                               size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code"
                               :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoHotcodeMixcutList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addVideoHotcodeMixcut"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editVideoHotcodeMixcut(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteVideoHotcodeMixcut(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportVideoHotcodeMixcutList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshVideoHotcodeMixcutList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoHotcodeMixcutList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="mexcutTitle"
        label="混剪标题"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="mexcutSubtitles"
        label="混剪字幕"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSrcs"
        label="混剪视频源地址"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoPic"
        label="剪混后的视频图片"
        min-width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.videoPic">
                  <el-image
                      @click='updateSrcList(scope.row.videoPic)'
                      style="width: 60px; height: 60px"
                      :src="scope.row.videoPic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSrc"
        label="混剪后的视频地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSize"
        label="视频大小"
        width="180"
      >
          <template slot-scope='scope'>
              {{scope.row.videoSize ? (scope.row.videoSize / 1024 /1024).toFixed(2) + 'M' : '--'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="mexcutStatus"
        label="混剪状态"
        width="180"
      >
          <template slot-scope='scope'>
              {{returnStatus(scope.row.mexcutStatus)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                  <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                  <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                  <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--              <div @click="viewVideo(scop.row.videoSrcs)">-->
<!--                  <Icon size="16">-->
<!--                      <Eye24Regular />-->
<!--                  </Icon>-->
<!--                  <span class="operation-label">播放混剪前视频</span>-->
<!--              </div>-->
<!--              <div @click="viewVideo(scop.row.videoSrc)">-->
<!--                  <Icon size="16">-->
<!--                      <Eye24Regular />-->
<!--                  </Icon>-->
<!--                  <span class="operation-label">播放混剪后视频</span>-->
<!--              </div>-->
              <div @click="openVideos(scop.row)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">查看视频列表</span>
              </div>
            <div @click="checkVideoHotcodeMixcut(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editVideoHotcodeMixcut(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteVideoHotcodeMixcut(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoHotcodeMixcutStates[videoHotcodeMixcutState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoHotcodeMixcut"
          ref="videoHotcodeMixcutForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="混剪标题"
            prop="mexcutTitle"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.mexcutTitle"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="混剪字幕"
            prop="mexcutSubtitles"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.mexcutSubtitles"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="混剪视频源地址"
            prop="videoSrcs"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.videoSrcs"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="剪混后的视频图片"
            prop="videoPic"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.videoPic"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="混剪后的视频地址"
            prop="videoSrc"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.videoSrc"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频大小"
            prop="videoSize"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="videoHotcodeMixcut.videoSize"
              :disabled="videoHotcodeMixcutState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="混剪状态"
            prop="mexcutStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="videoHotcodeMixcut.mexcutStatus"-->
<!--              :disabled="videoHotcodeMixcutState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                v-model="videoHotcodeMixcut.mexcutStatus"
                placeholder="请选择"
                style="width: 177px"
                :disabled="videoHotcodeMixcutState == 'check'"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="videoHotcodeMixcut.userId"-->
<!--              :disabled="videoHotcodeMixcutState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                           :value="videoHotcodeMixcut.userId" :limit='1' :disabled="videoHotcodeMixcutState == 'check'"
                           size='small' placeholder='请选择用户' @getValue="getValueUser" :columns="USER_code"
                           :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoHotcodeMixcutState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <!-- 查看视频列表 -->
      <el-dialog
          title="查看视频列表"
          :visible.sync="videosDialog"
          width="400px"
          @close="closeVideos"
      >
          <div>
              <el-form
                  :model="videos"
                  label-width="60px"
                  size="small"
              >
                  <el-form-item
                      label="混剪前"
                      prop="videoSrcs"
                  >
                      <el-tag style="margin-right: 10px;margin-bottom: 10px;cursor: pointer" v-for="(item,index) in videos.videoSrcs" :key="index" @click="viewVideo(item)">{{'视频' + (index + 1)}}</el-tag>
                  </el-form-item>
                  <el-form-item
                      label="混剪后"
                      prop="videoPic"
                  >
                      <div v-if="videos.videoPic && videos.videoStatus == 2" @click='viewVideo(videos.videoSrc)'>
                          <el-image
                              @click='viewVideo(videos.videoSrc)'
                              style="width: 100px; height: 100px"
                              :src="videos.videoPic"
                          > </el-image>
                      </div>
                      <div v-else>--</div>
                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeVideos">关闭</el-button>
<!--              <el-button-->
<!--                  type="primary"-->
<!--                  @click="submitForm"-->
<!--                  v-if="videoHotcodeMixcutState != 'check'"-->
<!--              >确定</el-button>-->
          </div>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoHotcodeMixcutList();
                    this.getVideoHotcodeMixcutList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoHotcodeMixcutList();
                    this.getVideoHotcodeMixcutList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     mexcutTitle: '', //混剪标题
                     mexcutSubtitles: '', //混剪字幕
                     videoSrcs: '', //混剪视频源地址
                     videoPic: '', //剪混后的视频图片
                     videoSrc: '', //混剪后的视频地址
                     videoSize: '', //视频大小
                     mexcutStatus: '', //混剪状态
                     userId: '', //用户ID
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoHotcodeMixcutState: 'add',
                videoHotcodeMixcutStates: {
                    add: '新建混剪视频',
                    check: '查看混剪视频',
                    edit: '修改混剪视频'
                },

                multipleSelection: [],
                videoHotcodeMixcutList: [],
                videoHotcodeMixcut: {
                    id: '', //ID
                    mexcutTitle: '', //混剪标题
                    mexcutSubtitles: '', //混剪字幕
                    videoSrcs: '', //混剪视频源地址
                    videoPic: '', //剪混后的视频图片
                    videoSrc: '', //混剪后的视频地址
                    videoSize: '', //视频大小
                    mexcutStatus: '', //混剪状态
                    userId: '', //用户ID
                },
                btnLoading: false,

                rules: {
                    mexcutTitle: [{ required: true, message: '混剪标题不能为空', trigger: 'blur' }],
                    mexcutSubtitles: [{ required: true, message: '混剪字幕不能为空', trigger: 'blur' }],
                    videoSrcs: [{ required: true, message: '混剪视频源地址不能为空', trigger: 'blur' }],
                    videoPic: [{ required: true, message: '剪混后的视频图片不能为空', trigger: 'blur' }],
                    videoSrc: [{ required: true, message: '混剪后的视频地址不能为空', trigger: 'blur' }],
                    videoSize: [{ required: true, message: '视频大小不能为空', trigger: 'blur' }],
                    mexcutStatus: [{ required: true, message: '混剪状态不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                },
                statusList: [],

                videosDialog: false,
                videos:{
                    videoSrcs: [],
                    videoSrc: '',
                    videoPic: '',
                    videoStatus: ''
                }
            };
        },
        created() {
            this.getVideoHotcodeMixcutList();
            this.getStatusList()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSeachValueUser(value) {
                this.queryForm.userId = value;
            },
            getValueUser(value) {
                this.videoHotcodeMixcut.userId = value;
            },
            openVideos(item){
                this.videosDialog = true;
                let array = []
                if(item.videoSrcs){
                    array = item.videoSrcs.split(',')
                }
                this.videos = {
                    videoSrcs: array,
                    videoPic: item.videoPic || "http://ss.png",
                    videoSrc: item.videoSrc,
                    videoStatus: item.mexcutStatus
                };
            },
            closeVideos(){
                this.videosDialog = false;
                this.videos = {
                    videoSrcs: [],
                    videoSrc: '',
                    videoStatus: ''
                };
            },
            getStatusList(){
                get('/video/utils/getEnum', { enumType: 'mix_cut_status' }).then(res => {
                    this.statusList = res.enumList;
                })
            },
            returnStatus(status){
                for(let i = 0; i < this.statusList.length; i++){
                    if(this.statusList[i].key == status){
                        return this.statusList[i].value
                    }
                }
            },
            resetVideoHotcodeMixcutList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoHotcodeMixcutList = [];
            },
            resetDialog() {
                this.videoHotcodeMixcutState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      mexcutTitle: '', //混剪标题
                      mexcutSubtitles: '', //混剪字幕
                      videoSrcs: '', //混剪视频源地址
                      videoPic: '', //剪混后的视频图片
                      videoSrc: '', //混剪后的视频地址
                      videoSize: '', //视频大小
                      mexcutStatus: '', //混剪状态
                      userId: '', //用户ID
                };
                this.getVideoHotcodeMixcutList();
            },
            viewVideo(url){
                window.open(url)
            },
            updateSrcList(url){
                this.srcList[0] = url
            },
            closeDialog() {
                this.showDialog = false
                this.videoHotcodeMixcut = {
                      id: '', //ID
                      mexcutTitle: '', //混剪标题
                      mexcutSubtitles: '', //混剪字幕
                      videoSrcs: '', //混剪视频源地址
                      videoPic: '', //剪混后的视频图片
                      videoSrc: '', //混剪后的视频地址
                      videoSize: '', //视频大小
                      mexcutStatus: '', //混剪状态
                      userId: '', //用户ID
                };
            },
            submitForm() {
                if (this.videoHotcodeMixcutState == 'add') {
                    this.$refs.videoHotcodeMixcutForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodemixcut/add`,{ ...this.videoHotcodeMixcut }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoHotcodeMixcutList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.videoHotcodeMixcutState == 'edit') {
                    this.$refs.videoHotcodeMixcutForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcodemixcut/edit`,{ ...this.videoHotcodeMixcut }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoHotcodeMixcutList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addVideoHotcodeMixcut() {
                this.showDialog = true;
                this.videoHotcodeMixcutState = 'add';
            },
            checkVideoHotcodeMixcut(videoHotcodeMixcutId) {
                console.log(videoHotcodeMixcutId);
                this.currentVideoHotcodeMixcutId = videoHotcodeMixcutId;

                this.getVideoHotcodeMixcutById();
                this.showDialog = true;
                this.videoHotcodeMixcutState = 'check';
            },
            editVideoHotcodeMixcut(videoHotcodeMixcutId) {
                console.log('videoHotcodeMixcut', videoHotcodeMixcutId);
                if (videoHotcodeMixcutId) {
                    this.currentVideoHotcodeMixcutId = videoHotcodeMixcutId;
                    this.getVideoHotcodeMixcutById();
                } else {
                    this.videoHotcodeMixcut = { ...this.videoHotcodeMixcut, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoHotcodeMixcutState = 'edit';
            },
            deleteVideoHotcodeMixcut(videoHotcodeMixcutId) {
                let ids = '';
                if (videoHotcodeMixcutId) {
                    ids = videoHotcodeMixcutId;
                } else {
                    ids = this.multipleSelection.map((videoHotcodeMixcut) => videoHotcodeMixcut.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/hotcodemixcut/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoHotcodeMixcutList();
                                this.getVideoHotcodeMixcutList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoHotcodeMixcutList() {
                this.resetVideoHotcodeMixcutList();
                this.getVideoHotcodeMixcutList();
            },
            getVideoHotcodeMixcutList(query = {}) {
                this.loading = true;
                get(`/video/hotcodemixcut/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.videoHotcodeMixcutList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getVideoHotcodeMixcutById() {
                get(`/video/hotcodemixcut/get`,{ id: this.currentVideoHotcodeMixcutId }).then((res) =>{
                    if(res.success){
                      this.videoHotcodeMixcut = { ...this.videoHotcodeMixcut, ...res.videoHotcodeMixcut };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoHotcodeMixcutList() {
                //this.btnLoading = true;
                exprotExcel(`/video/hotcodemixcut/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/hotcodemixcut/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/hotcodemixcut/importData`,formData);
              this.refreshVideoHotcodeMixcutList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoHotcodeMixcutList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoHotcodeMixcutList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>